export default "__VITE_ASSET__CPuU2IzB__"